import { useMemo } from "react";
import { Divider } from "@fluentui/react-components";
import { Label, RadioButton, TextStyle, Button } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";
import { ReactComponent as PCILogo } from "../../assets/images/PCI-Logo.svg";
import { ReactComponent as SahlLogo } from "../../assets/images/Sahl-Logo.svg";

import { PaymentMethodType } from '../../common/constans';
import Wallet from './wallet';
import CardDetailsForm from './cardDetailsForm';

const PaymentMethods = ({
    isCardEnabled,
    isWalletEnabled,
    handleChange,
    onSubmit,
    isLoading,
    onChangeSelectedPaymentMethod,
    isFormValid,
    amount,
    currency,
    isSaveCardOptionEnabled }) => {

    const options = useMemo(() => {
        const opts = [];
        if (isCardEnabled) {
            opts.push({
                label: "Debit or Credit Card",
                value: PaymentMethodType.BankCard,
                icon: <CardIcon />,
                content: () => <CardDetailsForm handleChange={handleChange} isSaveCardOptionEnabled={isSaveCardOptionEnabled} />
            });
        }
        if (isWalletEnabled) {
            opts.push({
                label: "Digital Wallet",
                value: PaymentMethodType.Wallet,
                icon: <EmptyWallet />,
                content: () => <Wallet handleChange={handleChange} />
            });
        }
        return opts;
    }, [isCardEnabled, isWalletEnabled, handleChange, isSaveCardOptionEnabled]);

    return (
        <div> 
            <div style={styles.card}>
                <Label labelText="Choose your payment method" textStyle={TextStyle.Heading5Semibold} />
                <RadioButton
                    options={options}
                    defaultValue={PaymentMethodType.BankCard}
                    onChange={(value) => onChangeSelectedPaymentMethod(Number(value))}
                />
            </div>

            <div style={{ display: "grid", padding: "12px 0" }}>
                <Button onClick={(e) => onSubmit(e)} isLoading={isLoading} disabled={!isFormValid}>
                    {`Pay ${amount} ${currency}`}
                </Button>
            </div>

           <div style={styles.row}>
                <div style={styles.sahl}>
                    <Label labelText="Powered by" textStyle={TextStyle.BaseRegular} />
                    <SahlLogo />
                </div>
                <div style={{ maxWidth: "fitContent" }}>
                    <Divider vertical />
                </div>
                <PCILogo />
            </div>
        </div>
    );
}

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #565765",
    backgroundColor: "#FFFFFF",
    alignItems: "flext-start",
    alignSelf: "stretch",
  },
  row: {
    display: "flex",
    padding: "12px 0 0 0",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    alignSelf: "stretch",
  },
  sahl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  }
};

export default PaymentMethods;
